export const createService = {
  title: 'Create Service'
};
